<div class="no-conversations">You have no conversations.</div>
<div class="no-conversations">
  Contact a service provider with the <strong>'Contact'</strong> button on the
  Find Services page.
</div>
